<template>
  <div>
    <div class="inner">
      <h2 class="Head Head--cl01 Head--sp-cl01 Head--mg_md">
        <span
          class="Head__main Head--md"
        >Today’s class</span><br><span class="Head__main_jp">今日のクラス</span>
      </h2>
    </div>
    <div class="Card__inner inner">
      <div class="Card__area Card__schedule_area">
        <div
          v-if="featuredItem"
          :class="`Card__box_list_main Card__box--${classStatus}`"
          @click="handleFirstClass(featuredItem.id)"
        >
          <div v-if="featuredItem.is_canceled" class="Label__op Card__box_op_label Card__box_op_label--canceled">
            休講
          </div>
          <div v-else class="Label__op Card__box_op_label">
            開催中
          </div>
          <div
            class="Card__box Card__box--lg Card__box_first"
            :style="parseCssVars(featuredItem.master_program_category)"
          >
            <div :class="'Card__box_label' + (featuredItem.is_recorded ? ' Card__box_label--recorded' : '')">
              <span class="Card__box_label_time">
                {{ featuredItem.learning_time }}
              </span>
              <span class="Card__box_label_class">
                <img
                  :src="featuredItem.master_program_category.c_icon_url"
                  alt="icon"
                  class="Card__box_label_icon"
                >
                {{ featuredItem.class }}
              </span>
              <span class="Card__box_label_name">
                <img
                  :src="showAvatar(featuredItem.master_instructor)"
                  alt="avatar"
                  class="Card__box_label_avatar"
                >
                {{ featuredItem.master_instructor.name }}
              </span>
            </div>
            <div class="Label Label__time Card__box_time_label">
              {{ featuredItem.time }} 分
            </div>
          </div>
        </div>
        <div
          v-for="(item,key) of listScheduleToDay"
          :key="key"
          :class="`Card__box_list ${item.is_new_date ? 'Card__date' : ''}`"
          @click="openModalSchedule(item.id)"
        >
          <div class="Card__date_area">
            <div class="Card__date_box">
              <span class="Card__date_box_tx">{{ handleDateToDay(item.date) }}</span>
            </div>
          </div>
          <div class="Card__box_top">
            <div class="Label Label__time Card__box_time_label_secondary">
              {{ item.time }} 分
            </div>
          </div>
          <div
            class="Card__box Card__box--sm"
            data-modal-open="modal-1"
            :style="parseCssVars(item.master_program_category)"
          >
            <div
              :class="'Card__box_label Card__box_label_secondary' +
                (item.is_canceled ? ' Card__box_label--canceled' : (item.is_recorded ? ' Card__box_label--recorded' : ''))"
            >
              <span class="Card__box_label_time">
                <img
                  :src="item.master_program_category.c_icon_url"
                  alt="icon"
                  class="Card__box_label_icon"
                >
                {{ item.learning_time }}
              </span>
              <span class="Card__box_label_class">
                {{ item.class }}
              </span>
              <span class="Card__box_label_name">
                <img
                  :src="showAvatar(item.master_instructor)"
                  alt="avatar"
                  class="Card__box_label_avatar"
                >
                {{ item.master_instructor.name }}
              </span>
            </div>
            <div class="Label Label__time Card__box_time_label">
              {{ item.time }} 分
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ScheduleToDay from '@/services/scheduleService'
import moment from 'moment'
import { parseCssVars } from '@/helpers/programCategory'
import { convertAvatar } from '@/helpers'

export default {
  data() {
    return {
      listScheduleToDay: [],
      featuredItem: null,
      timestamp: '',
      nextDay: 0,
      classStatus: 'not_open',
      oneMinutesMillisecond: 60 * 1000,
      fiveMinutesMillisecond: 5 * 60 * 1000,
      tenMinutesMillisecond: 10 * 60 * 1000,
      oneMonthMillisecond: 30 * 24 * 60 * 60 * 1000
    }
  },
  mounted() {
    this.getListScheduleToDay()
  },
  methods: {
    handleDateToDay(date) {
      return moment(date).locale('ja').format('MMMDo(ddd)')
    },
    openModalSchedule(scheduleId, isOngoingClass) {
      this.$store.dispatch('modal/openModalSchedule', { scheduleId, isOngoingClass })
    },
    async getListScheduleToDay() {
      const response = await ScheduleToDay.classToday()
      if (response.data.length !== 0) {
        response.data.forEach(element => {
          element.date = moment(element.date).local()
          element.learning_time = element.date.format('HH:mm')
        })
        this.getClassFromNow(response.data)
      }
    },
    getClassFromNow(schedules) {
      const today = moment()._d
      const miniSeconds = Date.parse(today)
      const result = []
      schedules.forEach(element => {
        const format_time_ios = moment(element.date).format('YYYY/MM/DD HH:mm:ss')
        if (Date.parse(format_time_ios) + element.time * this.oneMinutesMillisecond >= miniSeconds) {
          result.push(element)
        }
      })
      if (result.length !== 0) {
        this.sortSchedule(result)
      }
    },
    sortSchedule(schedules) {
      const now = moment()._d
      if (schedules[1]) {
        const format_time_ios_first = moment(schedules[0].date).format('YYYY/MM/DD HH:mm:ss')
        const format_time_ios_second = moment(schedules[1].date).format('YYYY/MM/DD HH:mm:ss')
        if (Date.parse(now) >= Date.parse(format_time_ios_second) - this.tenMinutesMillisecond &&
          Date.parse(now) >= Date.parse(format_time_ios_first) + schedules[0].time * this.oneMinutesMillisecond
        ) {
          this.listScheduleToDay = schedules.slice(1, 9)
        } else {
          this.listScheduleToDay = schedules.slice(0, 8)
        }
      } else {
        this.listScheduleToDay = schedules.slice(0, 8)
      }
      this.featuredItem = this.listScheduleToDay.shift()
      this.checkClassOpen(this.featuredItem)
      this.handleNextDay(this.listScheduleToDay)
    },
    handleNextDay(schedules) {
      const featuredItemDay = this.featuredItem.date
      const listDate = []
      let currentListDate = null
      schedules.forEach(function(item, key) {
        let isNewDate = false
        if (item.date !== null) {
          if (!currentListDate || currentListDate !== moment(item.date).format('YYYY/MM/DD')) {
            currentListDate = moment(item.date).format('YYYY/MM/DD')
            if (currentListDate === moment(featuredItemDay).format('YYYY/MM/DD')) {
              isNewDate = false
            } else {
              isNewDate = true
            }
          }
          const itemClass = item
          itemClass.is_new_date = isNewDate
          listDate.push(itemClass)
        }
      })
      this.listScheduleToDay = listDate
    },
    checkClassOpen(data) {
      const now = moment()._d
      const format_time_ios = moment(data.date).format('YYYY/MM/DD HH:mm:ss')
      if (Date.parse(now) >= Date.parse(format_time_ios) - this.tenMinutesMillisecond && Date.parse(now) <= Date.parse(format_time_ios) + data.time * this.oneMinutesMillisecond) {
        this.classStatus = 'open'
      } else {
        this.classStatus = 'not_open'
      }
    },
    handleFirstClass(scheduleId) {
      this.openModalSchedule(scheduleId, this.classStatus === 'open')
    },
    showAvatar(instructor) {
      let url = null
      if (instructor) {
        url = instructor.image_url
      }
      return convertAvatar(url)
    },
    parseCssVars: parseCssVars
  }
}
</script>
